<template>
  <v-container fluid class="pa-2">
    <!-- Vista de escritorio para pantallas md y mayores -->
    <v-toolbar flat class="mb-6">
      <h3>Movimientos de inventario</h3>
      <v-spacer></v-spacer>
      <v-menu open-on-hover transition="slide-x-transition" bottom right offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" class="warning" v-on="on" fab>
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <v-list class="pa-0">
          <v-list-item to="IAIn">
            <v-avatar size="24" class="mr-2">
              <v-icon>mdi-package-variant-plus</v-icon>
            </v-avatar>
            <v-list-item-title>Ajustes de Entrada a inventario</v-list-item-title>
          </v-list-item>
          <v-list-item to="IAOut">
            <v-avatar size="24" class="mr-2">
              <v-icon>mdi-package-variant-minus</v-icon>
            </v-avatar>
            <v-list-item-title>Ajustes de Salida de inventario</v-list-item-title>
          </v-list-item>

          <v-list-item to="WarrantyIn">
            <v-avatar size="24" class="mr-2">
              <v-icon>mdi-package-variant-plus</v-icon>
            </v-avatar>
            <v-list-item-title>Entrada a Garantia</v-list-item-title>
          </v-list-item>
          <v-list-item to="WarrantyOut">
            <v-avatar size="24" class="mr-2">
              <v-icon>mdi-package-variant-minus</v-icon>
            </v-avatar>
            <v-list-item-title>Salida de Garantia</v-list-item-title>
          </v-list-item>
          <v-list-item to="Warehouse">
            <v-avatar size="24" class="mr-2">
              <v-icon>mdi-truck-fast-outline </v-icon>
            </v-avatar>
            <v-list-item-title>Traslado de Bodega</v-list-item-title>
          </v-list-item>
          <v-list-item to="Promotion">
            <v-avatar size="24" class="mr-2">
              <v-icon>mdi-sale </v-icon>
            </v-avatar>
            <v-list-item-title>Traslado a Promoción</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-card class="d-none d-md-block">
      <v-row class="pa-2">
        <v-col cols="3">
          <v-select
            v-model="even_code"
            :items="events_list"
            item-value="code"
            item-text="name"
            label="Tipo de Movimiento"
            placeholder="Codigo"
            clearable
            hide-details="auto"
            outlined
            :rules="f_required"
            @change="filter_data"
            dense
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="dateFrom"
            label="Desde"
            hide-details="auto"
            required
            dense
            outlined
            type="date"
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="dateTo"
            label="Hasta"
            hide-details="auto"
            required
            dense
            outlined
            type="date"
          />
        </v-col>
        <v-col cols="3">
          <v-btn color="success" @click="get_report">Buscar</v-btn>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="filteredData"
        :items-per-page="5"
        item-key="id"
        sort-by="name"
        calculate-widths
        :loading="loading_status"
        loader-height="10"
        loading-text="Cargando ..."
        @click:row="get_e_doc"
        :class="{ 'cursor-pointer': !loading_status }"
      >
        <template v-slot:[`item.costo`]="{ item }">
          <span>{{ "$" + parseFloat(item.costo).toLocaleString(2) }}</span>
        </template>
        <template v-slot:[`item.price`]="{ item }">
          <span>{{ "$" + parseFloat(item.price).toLocaleString(2) }}</span>
        </template>
        <template v-slot:[`item.tcost`]="{ item }">
          <span>{{ "$" + parseFloat(item.tcost).toLocaleString(2) }}</span>
        </template>
        <template v-slot:[`item.tprice`]="{ item }">
          <span>{{ "$" + parseFloat(item.tprice).toLocaleString(2) }}</span>
        </template>
        <template slot="body.append">
          <tr>
            <th>Total</th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th class="text-right">{{ sumTable("items", "quantity") }}</th>
            <th></th>
            <th class="text-right"></th>
            <th class="text-right">{{ "$" + sumTable("items", "tcost") }}</th>
            <th class="text-right">{{ "$" + sumTable("items", "tprice") }}</th>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <!-- Vista móvil solo para xs y sm -->
    <v-card class="d-md-none elevation-4">
      <v-row class="px-3">
        <v-col cols="12" sm="6">
          <v-select
            v-model="even_code"
            :items="events_list"
            item-value="code"
            item-text="name"
            label="Tipo de Movimiento"
            placeholder="Codigo"
            clearable
            hide-details="auto"
            outlined
            :rules="f_required"
            @change="filter_data"
            dense
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="dateFrom"
            label="Desde"
            hide-details="auto"
            required
            dense
            outlined
            type="date"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="dateTo"
            label="Hasta"
            hide-details="auto"
            required
            dense
            outlined
            type="date"
          />
        </v-col>
        <v-col cols="12" class="text-center">
          <v-btn color="success" @click="get_report">Buscar</v-btn>
        </v-col>
      </v-row>

      <v-list two-line>
        <v-list-item-group>
          <template>
            <v-list-item
              v-for="item in filteredData"
              :key="item.id"
              @click="get_e_doc(item)"
              class="cursor-pointer"
            >
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">
                  {{ item.order_number }} - {{ getEventName(item.order_number) }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <span>{{ item.order_date }}</span>
                  <span class="ml-2">{{ item.refe }} - {{ item.color }}</span>
                </v-list-item-subtitle>

                <div class="d-flex mt-1">
                  <span class="caption mr-2"
                    >Cant: <b>{{ item.quantity }}</b></span
                  >
                  <span class="caption"
                    >Talla: <b>{{ item.talla }}</b></span
                  >
                </div>
              </v-list-item-content>
              <v-list-item-action>
                <div class="text-right">
                  <div class="font-weight-bold">
                    {{ "$" + parseFloat(item.tprice).toLocaleString(2) }}
                  </div>
                  <div class="caption grey--text">
                    Costo: {{ "$" + parseFloat(item.tcost).toLocaleString(2) }}
                  </div>
                </div>
              </v-list-item-action>
            </v-list-item>
            <v-divider
              v-if="index < filteredData.length - 1"
              :key="'div-' + index"
            ></v-divider>
          </template>
        </v-list-item-group>
      </v-list>

      <!-- Estados de la lista: cargando y vacío -->
      <div v-if="loading_status" class="text-center my-4">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        <div class="mt-2">Cargando...</div>
      </div>

      <div
        v-if="!loading_status && filteredData.length === 0"
        class="text-center my-4 pa-4"
      >
        <v-icon large color="grey lighten-1">mdi-file-document-outline</v-icon>
        <div class="grey--text">No hay movimientos disponibles para este período</div>
      </div>

      <!-- Totales en móvil -->
      <v-card-actions v-if="filteredData.length > 0" class="grey lighten-4">
        <v-row class="px-3 py-2">
          <v-col cols="4" class="py-0">
            <div class="caption grey--text">Cant. Total</div>
            <div class="font-weight-bold">{{ sumTable("items", "quantity") }}</div>
          </v-col>
          <v-col cols="4" class="py-0">
            <div class="caption grey--text">Costo Total</div>
            <div class="font-weight-bold">${{ sumTable("items", "tcost") }}</div>
          </v-col>
          <v-col cols="4" class="py-0">
            <div class="caption grey--text">Precio Total</div>
            <div class="font-weight-bold">${{ sumTable("items", "tprice") }}</div>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <noteViewer :item="item" :dialog="dialog" @close="dialog = false" />
  </v-container>
</template>

<script>
import { webserver, getToday, getdays_ago } from "../services/webserver.js";
import noteViewer from "../components/doc_viewer_report.vue";

export default {
  components: { noteViewer },
  data() {
    return {
      even_code: "",
      errors: [],
      valid: false,
      filteredData: [],
      loading_status: false,
      f_required: [(v) => !!v || "Requerido"],
      f_email: [
        (v) => !!v || "Correo valido",
        (v) => /.+@.+/.test(v) || "Correo no valido",
      ],
      imageUrl: null,
      dialog: false,
      headers: [
        {
          text: "Fecha",
          align: "start",
          sortable: true,
          value: "order_date",
          dataType: "text",
        },
        {
          text: "Documento",
          align: "start",
          sortable: true,
          value: "order_number",
          dataType: "text",
        },
        {
          text: "Categoría",
          align: "start",
          sortable: true,
          value: "categoria",
          dataType: "text",
        },
        {
          text: "Grupo",
          align: "start",
          sortable: true,
          value: "grupo",
          dataType: "text",
        },
        {
          text: "Marca",
          align: "start",
          sortable: true,
          value: "marca",
          dataType: "text",
        },
        {
          text: "Refe",
          align: "start",
          sortable: true,
          value: "refe",
          dataType: "text",
        },
        {
          text: "Color",
          align: "start",
          sortable: true,
          value: "color",
          dataType: "text",
        },
        {
          text: "Talla",
          align: "start",
          sortable: true,
          value: "talla",
          dataType: "text",
        },
        {
          text: "Cantidad",
          align: "end",
          sortable: true,
          value: "quantity",
          dataType: "number",
        },
        {
          text: "Costo Uni",
          align: "end",
          sortable: true,
          value: "costo",
          dataType: "number",
        },
        {
          text: "Precio Uni",
          align: "end",
          sortable: true,
          value: "price",
          dataType: "number",
        },
        {
          text: "Costo",
          align: "end",
          sortable: true,
          value: "tcost",
          dataType: "number",
        },
        {
          text: "Precio",
          align: "end",
          sortable: true,
          value: "tprice",
          dataType: "number",
        },
      ],
      events_list: [
        { code: "OP", name: "Orden de Pedido" },
        { code: "OC", name: "Orden de Compra" },
        { code: "AJ", name: "Ajuste" },
        { code: "CP", name: "Cambio de Precio" },
        { code: "EI", name: "Entrada Inventario" },
        { code: "SI", name: "Salida Inventario" },
        { code: "GI", name: "Ingreso garantia" },
        { code: "GS", name: "Salida Garantia" },
        { code: "PS", name: "Salida de Promocion" },
        { code: "PE", name: "Entrada de Promocion" },
        { code: "DV", name: "Devolucion" },
        { code: "CD", name: "Cambio de Documento" },
        { code: "TB", name: "Traslado Bodega" },
      ],
      items: [],
      item: { doc: null, items: [], payments: [] },
      dateFrom: getdays_ago(-30),
      dateTo: getToday(),
    };
  },
  mounted() {
    this.get_report();
  },
  methods: {
    getEventName(orderNumber) {
      // Extraer el prefijo (2 primeros caracteres)
      const prefix = orderNumber.substring(0, 2);

      // Buscar el evento correspondiente
      const event = this.events_list.find((e) => e.code === prefix);

      // Retornar el nombre si existe, o el prefijo si no
      return event ? event.name : prefix;
    },
    filter_data() {
      if (!this.even_code) {
        this.filteredData = this.items;
        return;
      }

      // Filtrar datos según el código seleccionado
      this.filteredData = this.items.filter((item) => {
        return item.order_number.startsWith(this.even_code);
      });
    },
    sumTable(table, key) {
      return parseFloat(
        this[table].reduce((a, b) => a + (parseFloat(b[key]) || 0), 0)
      ).toLocaleString(2);
    },
    get_report() {
      this.loading_status = true;
      var qry = {
        store: window.store.store_id,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        events: "'OP','OC','AJ','CP','EI','SI','GI','GS','PS','PE','DV','CD','TB'",
      };

      webserver("get_events", qry, (data) => {
        console.log(data);
        data.forEach((itm) => {
          itm.quantity = parseFloat(itm.quantity);
          itm.tcost = parseFloat(itm.quantity) * parseFloat(itm.costo);
          itm.tprice = parseFloat(itm.quantity) * parseFloat(itm.price);
        });
        this.loading_status = false;
        this.items = data;
        this.filteredData = data;
      });
    },
    get_e_doc(e) {
      console.log(e);

      var doc = {
        store: e.store,
        issueDate: e.order_date,
        did: e.order_number,
      };
      console.log(doc);
      webserver("get_invoice_fe", doc, (data) => {
        console.log(data);
        this.item = data;
        this.dialog = true;
      });
    },
  },
};
</script>

<style>
/* Estilos adicionales para mejorar la apariencia */
.v-list-item__subtitle {
  margin-top: 4px;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-pointer:hover {
  background-color: rgba(0, 0, 0, 0.03);
}
</style>
